function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { text120, white, spacing8, lineHeightTight } from "@churchofjesuschrist/eden-style-constants";
const IconStyled = styled(_ref => {
  let {
    Icon,
    ...props
  } = _ref;
  delete props.isThemed;
  delete props.float;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: "1.5rem"
  }, props));
}).withConfig({
  componentId: "sc-lcbmy6-0"
})(["fill:", ";line-height:", ";color:", ";", ";"], white, lineHeightTight, _ref2 => {
  let {
    isThemed,
    theme
  } = _ref2;
  return isThemed ? theme.primaryColor || text120 : white;
}, props => props.float && css(["position:absolute;bottom:", ";left:", ";"], spacing8, spacing8));

const Icon = _ref3 => {
  let {
    Icon,
    isThemed,
    theme,
    float,
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement(IconStyled, _extends({
    isThemed,
    float,
    theme,
    Icon
  }, props));
};

Icon.propTypes = {
  /** Icon to display */
  Icon: PropTypes.func.isRequired,

  /** Used to apply color to the icon, leave false if on an image */
  isThemed: PropTypes.bool,

  /** The theme (usually through context & styled-components) to apply */
  theme: PropTypes.shape({
    primaryColor: PropTypes.string
  }),

  /** If the icon is floating or relatively positioned */
  float: PropTypes.bool
};
export default Icon;